<div class="t-a-c">

    <div class="d-flex flex-column">
        <p>{{ data.createdByTitle }}: <strong>{{ data.createdBy }}</strong></p>
        <p>{{ data.createdDateTitle }}: <strong>{{ data.createdDate }}</strong></p>
        <p class="mb-1">{{ data.commentTitle }}:</p>
        <p [innerHTML]="data.comment"></p>
    </div>

    <button mat-flat-button (click)="ok()" class="m-r-5 btn-msg">
        Cerrar
    </button>
</div>